import styled from 'styled-components';

export const MobileHistoryFilterContainerStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 8px;
    button{
        &.selected {
            background: var(--color-yellow);
            color: var(--text-color-dark);
        }
        &:hover {
          background: var(--color-purple);
          border-color: var(--color-purple);
        }
        &.selected, &.selected:hover {
            background: var(--color-yellow);
            color: var(--text-color-dark);
        }
    }
`;
